import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const submitFileForEntityCreation = (fileId: string, type: any, tokens: any) => {
  console.log('htag type', type)

  const request: Request<{}> = {
    apiPath: getUrl(APIEndPoints.bulkOnboardUploadConfirm),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    body: {
      fileId: fileId,
      type:
        type === 'bulkUpload'
          ? 'CREATE'
          : type === 'bulkConfig'
          ? 'BULK_CONFIG'
          : type === 'bulkCard'
          ? 'BULK_CARD_CONFIG'
          : type === 'bulkVpa'
          ? 'BULK_VPA'
          : type === 'bulkStore'
          ? 'BULK_STORE'
          : type === 'bulkTerminal'
          ? 'BULK_TERMINAL'
          : type === 'MCC_EXPORT'
          ? 'BULK_MCC_OPS'
          : type === 'IFSC_EXPORT'
          ? 'BULK_IFSC_OPS'
          : type === 'PINCODE_EXPORT'
          ? 'BULK_PINCODE_OPS'
          : type === 'PROGRAM_CATEGORY_EXPORT'
          ? 'BULK_PROGRAM_CATEGORY_OPS'
          : type === 'BULK_STORE_UPDATE'
          ? 'BULK_STORE_UPDATE'
          : type === 'BULK_DEVICES'
          ? 'BULK_DEVICES'
          : type === 'BULK_TERMINAL_UPDATE'
          ? 'BULK_TERMINAL_UPDATE'
          : type === 'BULK_USER_MANAGEMENT'
          ? 'BULK_USER_MANAGEMENT'
          : type === 'CHECKER_1_BULK_CLAIM'
          ? 'BULK_CHECKER_ONE_CLAIM'
          : type === 'CHECKER_2_BULK_CLAIM'
          ? 'BULK_CHECKER_TWO_CLAIM'
          : type === 'CHECKER_1_BULK_ACTION'
          ? 'BULK_CHECKER_ONE_APPROVE'
          : type === 'CHECKER_2_BULK_ACTION'
          ? 'BULK_CHECKER_TWO_APPROVE'
          : 'SYNC',
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { submitFileForEntityCreation }
